import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Institution } from 'entities/institution'
import { ReactNode, useMemo } from 'react'
import { Button } from 'react-bootstrap'
import { Form } from 'utils/hooks'
import { InstitutionViewModel } from 'view_models/institution_view_model'

export const homeInstitutionColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'institution_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '施設コード', th: true, width: 90, align: 'center', form: form, orderAttr: 'institution_code', searchType: { name: 'code', type: 'text' } },
            { name: '施設名', th: true, minWidth: 250, form: form, orderAttr: 'institution_name', searchType: { name: 'nameIn', type: 'text' } },
            { name: '猶予日数', th: true, width: 80, align: 'center', form: form, orderAttr: 'institution_grace_days' },
            { name: '依頼書残数', th: true, width: 120, align: 'center', form: form, orderAttr: 'remaining_percent' },
        ],
    }
}

export type HomeInstitutionTableDataProps = {
    institution?: Institution
    displaySetting: DisplaySetting
    onClickRequestForm: () => void
    hovered: boolean
}

export const HomeInstitutionTableData = ({ institution, displaySetting, onClickRequestForm, hovered }: HomeInstitutionTableDataProps): JSX.Element => {
    if (!institution) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    const vm = new InstitutionViewModel(institution)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{institution.id}</TableCell>
                <TableCell align="center">{institution.code}</TableCell>
                <TableCell>
                    {institution.url ? (
                        <a target="_blank" rel="noreferrer" href={institution.url}>
                            {institution.name}
                        </a>
                    ) : (
                        institution.name
                    )}
                </TableCell>
                <TableCell align="center">{institution.graceDays}日</TableCell>
                <TableCell align="center">
                    <Button size="sm" onClick={onClickRequestForm}>
                        キット管理
                    </Button>
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList, hovered])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
